export const SKIPASS_KEYS = {
  HEADER: "[SKIPASS_INSURANCE_SKIPASS_HEADER]",
  INCLUDES_HEADER: "[SKIPASS_INSURANCE_INCLUDES_SKIPASS_HEADER]",
  INCLUDES: [
    "[SKIPASS_INSURANCE_INCLUDES_SKIPASS_FIRST]",
    "[SKIPASS_INSURANCE_INCLUDES_SKIPASS_SECOND]",
    "[SKIPASS_INSURANCE_INCLUDES_SKIPASS_THIRD]",
  ],
  INCLUDES_NOTE: "[SKIPASS_INSURANCE_INCLUDES_SKIPASS_FOURTH]",
  READMORE: "[SKIPASS_INSURANCE_SKIPASS_READMORE]",
  MODAL_TITLE: "[SKIPASS_READ_MORE_SKIPASS_MODAL_TITLE]",
  MODAL_BODY: "[SKIPASS_READ_MORE_SKIPASS_MODAL_BODY]",
  TERMS_LINK: "[SKIPASS_INSURANCE_TERMS_SKIPASS_LINK]",
  TERMS_TITLE: "[SKIPASS_INSURANCE_TERMS_SKIPASS_LINK_TITLE]",
} as const

export const SUBSCRIPTION_KEYS = {
  HEADER: "[SKIPASS_INSURANCE_SUBSCRIPTION_HEADER]",
  INCLUDES_HEADER: "[SKIPASS_INSURANCE_INCLUDES_SUBSCRIPTION_HEADER]",
  INCLUDES: [
    "[SKIPASS_INSURANCE_INCLUDES_SUBSCRIPTION_FIRST]",
    "[SKIPASS_INSURANCE_INCLUDES_SUBSCRIPTION_SECOND]",
    "[SKIPASS_INSURANCE_INCLUDES_SUBSCRIPTION_THIRD]",
  ],
  INCLUDES_NOTE: "[SKIPASS_INSURANCE_INCLUDES_SUBSCRIPTION_FOURTH]",
  READMORE: "[SKIPASS_INSURANCE_SUBSCRIPTION_READMORE]",
  MODAL_TITLE: "[SKIPASS_READ_MORE_SUBSCRIPTION_MODAL_TITLE]",
  MODAL_BODY: "[SKIPASS_READ_MORE_SUBSCRIPTION_MODAL_BODY]",
  TERMS_LINK: "[SKIPASS_INSURANCE_TERMS_SUBSCRIPTION_LINK]",
  TERMS_TITLE: "[SKIPASS_INSURANCE_TERMS_SUBSCRIPTION_LINK_TITLE]",
} as const
